<ag-grid-angular 
  style="width: 100%; height: 300px;"
  class="ag-theme-alpine"
  class="ag-theme-sg-bootstrap-condensed"
  [defaultColDef]="defaultColDef"
  [columnDefs]="columnDefs"
  [animateRows]="true"
  [rowData]="globalNoteIndicators"
  rowSelection="single">
</ag-grid-angular>